const SkeletonCard = () => (
    <div className="p-4 bg-white border rounded-lg w-1/4 animate-pulse">
        <div className="flex flex-row items-center justify-between mb-4">
            <div className="flex items-center gap-2">
                <div className="w-6 h-6 bg-gray-300 rounded"></div>
                <div className="h-6 w-20 bg-gray-300 rounded"></div>
            </div>
            <div className="h-4 w-12 bg-gray-300 rounded-full"></div>
        </div>
        <div className="mb-4">
            <div className="h-4 w-32 bg-gray-300 rounded mb-2"></div>
            <div className="h-4 w-24 bg-gray-300 rounded"></div>
        </div>
        <div className="mb-4">
            <div className="h-4 w-32 bg-gray-300 rounded mb-2"></div>
            <div className="h-4 w-24 bg-gray-300 rounded"></div>
        </div>
        <div>
            <div className="h-4 w-32 bg-gray-300 rounded mb-2"></div>
            <div className="h-4 w-24 bg-gray-300 rounded"></div>
        </div>
    </div>
);

const StatisticsTabSkeleton = () =>(
    <div className="w-full flex flex-col shadow-lg p-4 bg-white rounded-lg item-start">
        <div className="flex flex-col items-center mb-4 border-b border-gray-200">
            <div className="h-8 w-48 bg-gray-300 rounded mb-4 animate-pulse"></div>
        </div>
        <div className="h-6 w-32 bg-gray-300 rounded mb-4 animate-pulse"></div>
        <div className="flex flex-row justify-between gap-4 mb-4">
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
        </div>
        <div className="mb-4">
            <div className="h-6 w-48 bg-gray-300 rounded mb-4 animate-pulse"></div>
            <div className="p-4 w-full h-64 rounded-lg bg-gray-200 animate-pulse"></div>
        </div>
        <div className="mb-4">
            <div className="h-6 w-32 bg-gray-300 rounded mb-4 animate-pulse"></div>
            <div className="w-full h-64 rounded-lg bg-gray-200 animate-pulse"></div>
        </div>
    </div>
);


const AccountDetailsSkeleton = () => (
    <div className='w-full bg-white p-7 rounded-3xl shadow-lg'>
        {/* Lead Ownership Section */}
        <div className="flex justify-between items-start">
            <div className="flex items-center">
                <p className="font-bold text-2xl">Account Ownership</p>
            </div>
        </div>

        {/* Grid Container for All Rows */}
        <div className="grid grid-cols-2 gap-x-5 ml-5 text-[#475569]">
            {/* Product Ownership Section */}
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Name in MMT</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Account Source</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
                
            </div>

            {/* Contact Method and Lead Source */}
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Account Owner</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Hunter</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>

            <div className="flex items-center mt-5 mb-2">
                <p className="font-bold text-2xl -ml-5 w-full text-[#1E293B]">Product Associated</p>
            </div>
            <br></br>
            {/* Product Ownership Section - Display only Remittance Financing, Insurance, and Insurance Renewal */}
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3 gap-2 flex items-center">
                    <div className="h-5 w-5 bg-gray-300 rounded-lg animate-pulse"></div>
                    <b>Remittance</b>
                    </span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3 gap-2 flex items-center">
                    <div className="h-5 w-5 bg-gray-300 rounded-lg animate-pulse"></div>
                    <b>Financing</b>
                    </span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>

            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3 gap-2 flex items-center">
                    <div className="h-5 w-5 bg-gray-300 rounded-lg animate-pulse"></div>
                    <b>Insurance</b>
                    </span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3 gap-2 flex items-center">
                    <div className="h-5 w-5 bg-gray-300 rounded-lg animate-pulse"></div>
                    <b>Insurance Renewal</b>
                    </span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-center mt-5 mb-2">
                <p className="font-bold text-2xl -ml-5 w-full text-[#1E293B]">General Information</p>
            </div>
            <br></br>
            {/* MM Account ID */}
            <div className="col-span-2 flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/6"><b>MM Account ID</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            {/* Nature of Business and Industry */}
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Nature of Business</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Industry</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            {/* Relationship Strength */}
            <div className="col-span-2 flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/6"><b>Relationship Strength</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            {/* Street */}
            <div className="col-span-2 flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/6"><b>Street</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>

            {/* City */}
            <div className="col-span-2 flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/6"><b>City</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>

            {/* Post Code */}
            <div className="col-span-2 flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/6"><b>Post Code</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>

            {/* State */}
            <div className="col-span-2 flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/6"><b>State</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
        </div>
    </div>
);

const AccountDetailsSquareSkeleton = () => (
    <div className="w-full">
        {/* Outer White Container */}
        <div className="bg-white rounded-3xl shadow-sm p-6 ml-8 mr-8 mt-5">
            <div className="h-4 w-1/12 bg-gray-200 rounded-lg animate-pulse"></div>
            <div className="h-12 mt-2 mb-5 ml-1 animate-pulse rounded-lg bg-gray-300 w-1/2"></div>
    
            <div className="flex flex-row gap-2">
                <div className="w-1/12 bg-gray-300 h-[40px] py-2 px-5 gap-2 top-5 left-[22px] rounded-lg border animate-pulse"></div>
                <div className="w-1/12 bg-gray-300 h-[40px] py-2 px-5 gap-2 top-5 left-[22px] rounded-lg border animate-pulse"></div>
                <div className="w-1/12 bg-gray-300 h-[40px] py-2 px-5 gap-2 top-5 left-[22px] rounded-lg border animate-pulse"></div>
            </div>
        </div>
    </div>
)

const AccountDetailsRelatedTabSkeleton = () => (
    <div className='w-full bg-white p-7 rounded-3xl shadow-lg'>
        {/* Lead Ownership Section */}
        <div className="flex justify-between items-start">
            <div className="flex items-center">
                <p className="font-bold text-2xl text-[#1E293B]">Associated TT Information</p>
            </div>
        </div>

        {/* Grid Container for All Rows */}
        <div className="grid grid-cols-2 gap-x-5 ml-5 text-[#475569]">
            {/* Company Name and Hunter */}
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Frequency of TT</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-start mt-5">
                <p className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Next Expected TT</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </p>
            </div>

            {/* Contact Method and Lead Source */}
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Average TT Amount</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Previous TT Amount</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Tier</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Current Provider</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Current Rates</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Trade Facilities</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Reason of using TF</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3"><b>Percentage of TT</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="col-span-2 flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/6"><b>Currencies</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="col-span-2 flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/6"><b>Target Country</b></span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>

            <div className="flex items-center mt-5 mb-5">
                <p className="font-bold text-2xl -ml-5 w-full text-[#1E293B]">Associated Insurance Information</p>
            </div>
            <br></br>
            <div className="col-span-2 mb-4">
                <div className="p-4 w-full h-64 rounded-lg bg-gray-200 animate-pulse"></div>
            </div>
            <div className="flex items-center mt-5 mb-5">
                <p className="font-bold text-2xl -ml-5 w-full text-[#1E293B]">Associated Financing Information</p>
            </div>
            <br></br>
            <div className="col-span-2 mb-4">
                <div className="p-4 w-full h-64 rounded-lg bg-gray-200 animate-pulse"></div>
            </div>
            <div className="flex items-center mt-5 mb-5">
                <p className="font-bold text-2xl -ml-5 w-full text-[#1E293B]">Associated Opportunities</p>
            </div>
            <br></br>
            <div className="col-span-2 mb-4">
                <div className="p-4 w-full h-64 rounded-lg bg-gray-200 animate-pulse"></div>
            </div>
        </div>
        </div>
)

export {SkeletonCard, StatisticsTabSkeleton, AccountDetailsSkeleton, AccountDetailsSquareSkeleton, AccountDetailsRelatedTabSkeleton};
